function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.46596 2.34484V8.58344C7.46596 8.94245 7.17699 9.23349 6.81493 9.23349C6.45538 9.23349 6.16391 8.94216 6.16391 8.58344V2.34273L5.4286 3.07804C5.17671 3.32994 4.76817 3.32981 4.51216 3.0738C4.25792 2.81956 4.25942 2.40585 4.50791 2.15735L6.35778 0.307487C6.48303 0.182235 6.64701 0.119295 6.81171 0.119141L6.81668 0.121084C6.98202 0.121437 7.14642 0.18393 7.26998 0.307487L9.11984 2.15735C9.37174 2.40925 9.37161 2.81778 9.1156 3.0738C8.86136 3.32804 8.44765 3.32654 8.19916 3.07804L7.46596 2.34484ZM1.60674 12.1631H12.0231V7.60293C12.0231 7.24503 12.3121 6.9549 12.6742 6.9549C13.0337 6.9549 13.3252 7.24728 13.3252 7.60293V12.8171C13.3252 12.9959 13.2531 13.1578 13.1357 13.2751C13.0166 13.3927 12.8545 13.4651 12.675 13.4651H0.95483C0.775794 13.4651 0.613659 13.3933 0.496084 13.2764C0.377437 13.1567 0.304688 12.9948 0.304688 12.8171V7.60293C0.304688 7.24503 0.593654 6.9549 0.955712 6.9549C1.31526 6.9549 1.60674 7.24728 1.60674 7.60293V12.1631Z",
  fill: "#2D2E2C"
});

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Share.4a022063.svg";
export { ForwardRef as ReactComponent };